import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import RelatedServices from "@/components/RelatedServices";
import AnnouncementBar from "@/components/AnnouncementBar";
import WhatsAppFab from "@/components/WhatsAppFab";
import { SERVICE_MAP } from "@/data/services";

const PAGE_TITLES = {
  "/": "Home",
  "/services": "Services",
  "/process": "Process",
  "/about": "About",
  "/contact": "Contact",
  "/free-trial": "Free Trial",
};

function resolveTitle(pathname) {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  const m = pathname.match(/^\/services\/([^/]+)\/?$/);
  if (m && SERVICE_MAP[m[1]]) return SERVICE_MAP[m[1]].title;
  if (pathname.startsWith("/services/")) return "Services";
  return "Land Surveying CAD Drafting";
}

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    document.title = `cad4surveys | ${resolveTitle(pathname)}`;
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-zinc-50">
      <AnnouncementBar />
      <Header />
      <main className="flex-1" data-testid="app-main">
        <Outlet />
      </main>
      <RelatedServices />
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
